import React, { FC } from 'react';
import s from './PromptImageEditToolbar.module.css';
import { useSelector } from 'react-redux';
import { selectActivePrompt } from '../../../../store/selectors/pageSelectors';
import AdjustVisualsBlock from '../prompt-blocks/AdjustVisualsBlock';
import LayoutBlock from '../prompt-blocks/LayoutBlock';
import AdjustSizeBlock from '../prompt-blocks/AdjustSizeBlock';
import EffectsBlock from '../prompt-blocks/EffectsBlock';
import ImagePromptBlock from '../prompt-blocks/ImagePromptBlock';
import AddTextBlock from '../prompt-blocks/AddTextBlock';
import UploadsBlock from '../prompt-blocks/UploadsBlock';
import EnhanceBlock from '../prompt-blocks/EnhanceBlock';
import WizardBlock from '../prompt-blocks/WizardBlock';

const tabMap: Record<string, JSX.Element> = {
    adjust_visuals: <AdjustVisualsBlock />,
    layout: <LayoutBlock />,
    resize: <AdjustSizeBlock />,
    effects: <EffectsBlock />,
    image_prompt: <ImagePromptBlock />,
    add_text: <AddTextBlock />,
    image_uploads: <UploadsBlock />,
    enhance: <EnhanceBlock />,
    merger: <WizardBlock />,
};

const PromptImageEditToolbar: FC = () => {
    const activePrompt = useSelector(selectActivePrompt);

    if (!activePrompt) return null;
    return <div className={s.container}>{activePrompt ? tabMap[activePrompt] : null}</div>;
};

export default PromptImageEditToolbar;
